export default {
    methods:{
      handleHodads(type,status){ // 主页点击
         let teamId = status == 'home' ? this.h_key(type) : this.G_key(type)
         if(this.matchKey.includes(teamId)){
            this.getBetList = this.getBetList.filter(item=>{ return item.teamId != teamId })
         }else{
            let { matchName,season,srMatch,lastUpdate,srMarket,matchStatus } = type
            let limit = status == 'home' ? (type.hTeamLimit).split(','):(type.gTeamLimit).split(',')
            let teamname = status == 'home' ? type.hTeam : type.gTeam
            let teamodds = status == 'home' ? type.hOdds : type.gOdds
            let betValueId= status == 'home' ? '4' : '5'
            let onlyKey = status == 'home' ? type.hOnlyKey : type.gOnlyKey
            let active = status == 'home' ? type.hActive : type.gActive
            const newBest = { teamname,teamodds,teamId,money:1,limit,matchName,season,srMatch,lastUpdate,srMarket,betValueId,onlyKey,matchStatus,active,defaultType:'1' }
            this.getBetList.push(newBest)
         }
         sessionStorage.setItem('betList', JSON.stringify(this.getBetList));
         this.matchKey = Array.from(this.getBetList,({teamId}) => teamId)
         this.createdAgainListVo()
      },
      getActived(){  // 默认刷新
         this.matchKey = Array.from(this.getBetList,({teamId}) => teamId)
      },
      handleClickLight(val){  // 详情页面点击
         let teamId = val.srMatch + '' + val.srMarket + val.betValueId + val.onlyKey
         if(this.matchKey.includes(teamId)){
            this.getBetList = this.getBetList.filter(item=>{ return item.teamId != teamId })
         }else{
            let limit =val.limitLevel.split(',')
            let teamodds =val.odds
            let teamname = val.betName
            let matchName = val.marketName
            let lastUpdate = val.lastDate
            let matchStatus = this.$route.query.matchStatus
            let newBest = { ...val,money:1,limit,teamodds,teamname,matchName,lastUpdate,teamId,matchStatus,defaultType:'2', season:this.$route.query.sj}
            this.getBetList.push(newBest)
         }
         sessionStorage.setItem('betList', JSON.stringify(this.getBetList));
         this.matchKey = Array.from(this.getBetList,({teamId}) => teamId)
         this.createdAgainListVo()
      },
      G_HTeamrealTimeRefresh({ srMatch,match }){ // 主页面 webscokets数据更新
         if(this.renderList.length>0){
            this.HAVERENDERLIST=[]
            this.renderList.forEach((item,i)=>{
               this.HAVERENDERLIST.push(...item.arr)
               item.arr.forEach((val,j)=>{
                  let Items = this.renderList[i].arr
                  if(val.srMatch == srMatch){
                     this.$set(Items,j,{ ...val,...match })
                  }
               })
            })
         }
      },
      DetaileamrealTimeRefresh({ srMatch,info }){ // 详情页面 webscokets数据更新
         this.HAVESDETAILSARR = []
         if(this.detailsMatch.srMatch == srMatch){ this.detailArr=[] }
         for(let i in info){
            let Items = info[i]
            this.HAVESDETAILSARR.push(...Items)
            if(this.detailsMatch.srMatch == srMatch) { this.detailArr.push({ name:i,arr:Items }) }
         }
      },
      GoBetrealTimeRefresh({ match,srMatch }){
         if(this.getBetList.length > 0){
            let teamodds,active = ''
            this.getBetList.forEach((h,k)=>{
               if(h.teamId == this.h_key(match)){ teamodds = match.hOdds,active = match.hActive}
               else if(h.teamId == this.G_key(match)){ teamodds = match.gOdds,active = match.gActive }  
               if(srMatch == h.srMatch){
                  this.$set(this.getBetList,k,{ ...h,...{ teamodds,active,matchStatus:match.matchStatus } })
                  sessionStorage.setItem('betList', JSON.stringify(this.getBetList));
               }
            })
            this.detailArrComparedFun(this.HAVESDETAILSARR,match.matchStatus)
         
            this.createdAgainListVo()// 投注区中总计数据的更新
         }
      },
      createdAgainListVo(){
         this.againListVo =[]
         this.getBetList.forEach(item=>{  
            if(item.defaultType == '1'){ // 投注区主页
               let isbet =['live','not_started']
               if(isbet.includes(item.matchStatus) && item.active){
                  this.againListVo.push(item)
               }
            }else if(item.defaultType == '2'){ //投注区 详情页
               if(item.marketStatus == 'Active' && item.active){
                  this.againListVo.push(item)
               }
            } 
         })
      },
      initWebSocket(){
         if(typeof(WebSocket) === "undefined"){
           alert("您的浏览器不支持WebSocket")
           return false
         }else{
            this.websock = new WebSocket(this.wsuri)
            this.websock.onopen = this.websocketonopen
            this.websock.onmessage = this.websocketonmessage
            this.websock.onerror = this.websocketonerror
            this.websock.onclose = this.websocketclose
         }
      },
       //连接成功
	   websocketonopen(){ 
	      console.log('WebSocket连接成功')
	   },
	    //接收后端返回的数据
	   websocketonmessage(e){
         if(e.data !=='连接成功'){
            var dataJson = JSON.parse(e.data)
            this.wsJsonObj = { ...dataJson }
            this.DetaileamrealTimeRefresh(this.wsJsonObj)
            this.G_HTeamrealTimeRefresh(this.wsJsonObj)
            this.GoBetrealTimeRefresh(this.wsJsonObj)
         }
	    },
	    //连接建立失败重连
	   websocketonerror(e){
	      console.log(`连接失败的信息：`, e)
	      this.initWebSocket() // 连接失败后尝试重新连接
	    },
	    //关闭连接
	   websocketclose(e){ 
	      console.log('断开连接',e)
	   },
    }
}



// WEBPACK FOOTER //
// ./src/pages/build902/components/new-home/index.js